import { render, staticRenderFns } from "./CabeceraModalSimVista.vue?vue&type=template&id=50e9dbcb&scoped=true&"
import script from "./CabeceraModalSimVista.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalSimVista.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalSimVista.vue?vue&type=style&index=0&id=50e9dbcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e9dbcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('50e9dbcb', component.options)
    } else {
      api.reload('50e9dbcb', component.options)
    }
    module.hot.accept("./CabeceraModalSimVista.vue?vue&type=template&id=50e9dbcb&scoped=true&", function () {
      api.rerender('50e9dbcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SIMSolicitudes/CabeceraModalSimVista.vue"
export default component.exports